import { useQuery } from '@tanstack/react-query'
import { supabase } from '../lib/supabaseClient'
import { dummyShops } from '../lib/shopData'

// Custom hook to fetch shops data
// Uses React Query for caching and state management
export const useShops = () => {
  return useQuery({
    queryKey: ['shops'],
    queryFn: async () => {
      // Try to fetch from Supabase first
      try {
        const { data, error } = await supabase
          .from('shops')
          .select('*')
        
        if (error) throw error
        
        return data
      } catch (error) {
        console.log('Error fetching from Supabase, using dummy data:', error.message)
        // Fallback to dummy data if Supabase is not configured or fails
        return dummyShops
      }
    },
    // Initial data to use while fetching
    initialData: dummyShops,
    // Stale time of 5 minutes
    staleTime: 1000 * 60 * 5,
  })
}